export class AuthorizationDeniedError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'AuthorizationDeniedError';
  }
}
